import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BoardStageService } from '@board/services/board-stage.service';
import { BoardStage } from '@board/types/board-stage';

export const sceneLayoutResolver: ResolveFn<BoardStage> = (route) => {
  const service = inject(BoardStageService);

  return service.fetchStageByUuid(route.paramMap.get('stageUuid')!);
};
